import { Component, OnInit } from '@angular/core';
import { MetaService } from '../meta.service';

@Component({
  selector: 'app-partnership',
  templateUrl: './partnership.component.html',
  styleUrls: ['./partnership.component.css']
})
export class PartnershipComponent implements OnInit {

  //inject services
  constructor(private mds: MetaService) { }

  //initialize the component
  ngOnInit(): void {
    //SEO Optimization
    var strTitle = 'RegScale - Partnership';
    var description = 'RegScale partnership options for resellers, VARs, integrators, and others';
    var keywords = 'RegScale, partners, resellers, integrations, Atlasify, SIs, service providers, Accelerant, VARs, NIST OSCAL, MITRE Heimdall, Cloud Security Alliance (CSA)';
    this.mds.updateTags(strTitle, keywords, description);
  }

}
